import { render, staticRenderFns } from "./wtFacebookAsset.vue?vue&type=template&id=0c3cb5f7&"
import script from "./wtFacebookAsset.vue?vue&type=script&lang=js&"
export * from "./wtFacebookAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports